import { configGlobals, commonConfigGlobals } from './configGlobal'

export const registerComponents = (vm, id) => {
  // Desc: 使用配置动态添加组件 beforeCreate
  registerCommonComponents(vm)
  const config = configGlobals[id]
  if (!config) return // 在这里返回的都无需配置
  for (const prop in config) {
    const component = config[prop]
    if (component && component.component && component.tag) {
      if (vm.$options.components[component.tag]) {
        console.warn(`${id}-${prop}-${component.tag} 已经存在`)
      } else {
        vm.$options.components[component.tag] = component.component
      }
    }
  }
}

export const initComponents = (vm, id) => {
  // Desc: 使用配置动态添加组件声明 created
  initCommonComponents(vm)
  const config = configGlobals[id]
  if (!config) return // 在这里返回的都无需配置
  if (!vm.componentMap) return console.warn(`组件缺少 componentMap`)
  for (const prop in config) {
    vm.$set(vm.componentMap, prop, config[prop].tag)
  }
}
// 以下是公共组件需要的配置
export const registerCommonComponents = (vm) => {
  const config = commonConfigGlobals
  if (!config) return // 在这里返回的都无需配置
  for (const prop in config) {
    const component = config[prop]
    if (component && component.component && component.tag) {
      if (vm.$options.components[component.tag]) {
        console.warn(`${prop}-${component.tag} 已经存在`)
      } else {
        vm.$options.components[component.tag] = component.component
      }
    }
  }
}

export const initCommonComponents = (vm) => {
  // Desc: 使用配置动态添加组件声明 created
  const config = commonConfigGlobals
  if (!config) return // 在这里返回的都无需配置
  if (!vm.componentMap) return console.warn(`组件缺少 componentMap`)
  for (const prop in config) {
    vm.$set(vm.componentMap, prop, config[prop].tag)
  }
}
